import {endpointKeys} from '@common/api'
import {PartnerAdminPractitionerWorkingHourSummary} from '@common/models'
import {partnerAdminPractitionerWorkingHourSummariesNormaliser} from '@common/normalisers'

import {useWebGet, useApi} from './helpers'

/**
 * Hook to get aggregated practitioners working hours (Partner Admin scope)
 * Calls GET /api/v1/partner-administrators/practitioners/working-hours
 */
export const useGetPartnerAdminPractitionersWorkingHours = () =>
  useWebGet<PartnerAdminPractitionerWorkingHourSummary[]>(
    [endpointKeys.partnerAdminPractitionersWorkingHours],
    useApi().partnerAdminPractitionersWorkingHours(),
    partnerAdminPractitionerWorkingHourSummariesNormaliser,
  )
